<template>
    <div class="wrap">
        <div class="container container_top">
         <div class="pay_state">
            <div class="paid_cg">
                <van-image class="paid_img" src="https://www.xiangzh.com/static/index/default/images/failed.png">
                    <template v-slot:loading>
                        <van-loading type="spinner" size="20" />
                    </template>
                </van-image>
                <p>支付失败!</p>
            </div>
                <div class="paid_info_tree f-clearfix">
                    <span v-if="repayshow">请点击<a @click="go_repay" class="router-link-active">重试</a> 或者</span>
                    <div>
                        <van-button size="small" type="primary" @click="go_pay_re()">继续付款</van-button></div>
                    <div style="margin-top: 10px">
                        <router-link style="color: #888;font-size: 14px;" :to='home'>返回首页</router-link></div>
                </div>
            </div>
        </div>
        <v-foot></v-foot>
    </div>
</template>
<style>
.fixed-carts{
    display: none;
}
.container_top{margin-top:45px}
</style>
<script>
    // @ is an alias to /src
    export default {
        created() {
            // this.do_repay();
            window.fbq('trackCustom', 'pay_fail_h5', {"allmoney":0,"order_no":this.$route.query.out_trade_no});
            window.gtag('event', 'pay_fail_h5', { 'method' : 'pay_fail_h5',"order_no":this.$route.query.out_trade_no });
        },
        data() {
            return {
                "repayshow":false,
                "repay":"/",
                "home":"/",                
            }
        },
        methods: {
            do_repay(){
                var _this = this
                this.POST('api/order/pay',{"order_no":this.$route.query.out_trade_no},function (ret){
                    if(ret.code === 0){
                        // _this.repayshow = true;
                        _this.repay = ret.data.data;
                        _this.go_repay();
                    }
                })
            },
            go_repay(){
                this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                });
                window.location.href = this.repay;
            },
            go_pay_re(){
                this.$router.push('pay_re?order_no='+this.$route.query.out_trade_no);
            }
        },
    }
</script>